import React from 'react';
import'./Contact.css'
import {MdOutlineMail} from 'react-icons/md'
import {FaLinkedinIn} from 'react-icons/fa'
// import {FaLinkedin} from 'react-icons/fa'

import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import {FaTelegramPlane} from 'react-icons/fa';
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import image2 from '../../assets/contact2.svg'




import Lottie from 'react-lottie-player'
import contact from '../../assets/contact 2.json'

import { FaWhatsapp, } from "react-icons/fa";
import { HiOutlineMailOpen, HiOutlinePhone, HiOutlineLocationMarker } from "react-icons/hi";



const Contact = () => {



    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs
        .sendForm('service_6ms92yp', 'template_j6mg36n', form.current, {
          publicKey: 'O7sOjcOvR5dmDLYM3',
        })
        .then(
          () => {
            console.log('SUCCESS!');
          },
          (error) => {
            console.log('FAILED...', error.text);
          },
        );
    };






















    // const form = useRef();
  
    // const sendEmail = (e) => {
    //   e.preventDefault();
  
    //   emailjs.sendForm('service_vq0ngx5', 'template_gwy80yr', form.current, 'ZSGSOXwzVBHJe6MSO')
    //     .then((result) => {
    //         console.log(result.text);
    //     }, (error) => {
    //         console.log(error.text);
    //     });
    //     e.target.reset();
    // };
















    return (
  
        
        <section id='contact'>
            <h5>Get in Touch</h5>
            <h2>Contact Me</h2>
           
           
{/* 

<form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Message</label>
      <textarea name="message" />
      <input type="submit" value="Send" />
    </form> */}


















<div className='grid lg:grid-cols-3 grid-cols-1 gap-4'>
                <div className='px-3 lg:px-0 mt-12'>
                    <div className='text-lg'>
                        <p className='inline-flex items-center'><FaWhatsapp className='text-myGreen text-4xl me-4 my-1 bg-myDeepPurple hover:bg-myPurple rounded-full p-1' /> +880 1305553707</p>
                        <br />
                        <p className='inline-flex items-center'><HiOutlinePhone className='text-myGreen text-4xl me-4 my-1 bg-myDeepPurple hover:bg-myPurple rounded-full p-1' />  +880 1305553707</p>
                        <p className='inline-flex items-center'><HiOutlineMailOpen className='text-myGreen text-4xl me-4 my-1 bg-myDeepPurple hover:bg-myPurple rounded-full p-1' /> joyantichowdhury7070@gmail.com</p>
                        <p className='inline-flex items-center'><HiOutlineLocationMarker className='text-myGreen text-4xl me-4 my-1 bg-myDeepPurple hover:bg-myPurple rounded-full p-1' /> Chittagong, Bangladesh</p>
                    </div>
                    <div className='divider'></div>
                    {/* <Socials /> */}
                </div>
                <div>
                    <div className='contact'>
                        <Lottie
                            loop
                            animationData={contact}
                            play
                            className='h-96'
                        />
                    </div>
                </div>
                <div>
                    <form ref={form} onSubmit={sendEmail} className='px-3'>
                        <div>
                            <label className="label">Name</label>
                            <input type="text" name="name" required
                                placeholder='your name'
                                className="input bg-transparent input-bordered border  w-full contact"
                            />
                        </div>
                        <div>
                            <label className="label">Email</label>
                            <input type="email" name="email" required
                                placeholder='your email'
                                className="input bg-transparent input-bordered border contact w-full"
                            />
                            <div className='lg:col-span-2'>
                                <label className="label">Message</label>
                                <textarea name="message" required
                                    placeholder='your message here'
                                    className="textarea bg-transparent textarea-bordered  contact textarea-sm w-full border border-myPurple" />
                                <br />
                            </div>
                        </div>
                        {/* <input type="submit" value="Send"
                            className='myBtn bg-transparent shadow-md border  rounded-md w-full mt-3'
                        /> */}

<button type='submit' className='btn btn-primary'>Send</button>

                        
                    </form>
                  
                </div>
            </div>
             

        </section>
    );
};

export default Contact;